/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-29 17:21:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-28 17:36:53
 */
import {
  ExclamationCircleFilled,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Form,
  Col,
  Input,
  Modal,
  Row,
  notification,
  Checkbox,
  Button,
  message,
  Popover,
  InputNumber,
} from 'antd'
import { sum } from 'lodash'
import React, {
  ReactElement,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { traceRoute } from '../../../layouts/layoutSlice'
import { getBoilTypeName } from '../../../models/paymentresult'
import { getRecipeCategoryName, RecipeCategory } from '../../../models/recipe'
import { ThemeContext } from '../../../theme/ThemeContext'
import { setData } from '../../commodity/commoditySlice'
import { columns } from '../../department/columns'
import { payAgainAsync } from '../confirm/paymentConfirmSlice'
import { getPaymentResults } from '../result/paymentResultSlice'
import { ChargeAgainColumn, ChargeAgainTCMColumn } from './columns'
import styles from './Payments.module.css'
interface ChargeAgainModalProps {
  visible: boolean
  payAgainPayment?: any
  onCancel: () => void
  onOk: () => void
}

export const ChargeAgainModal = ({
  visible,
  payAgainPayment,
  onCancel,
  onOk,
}: ChargeAgainModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const theme = useContext(ThemeContext)

  const [result, setResult] = useState<any>()

  const [dataList, setDataList] = useState<any>()

  const [selectedIds, setSelectedIds] = useState<any>([])

  const [totalAmount, setTotalAmount] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [indeterminateStates, setIndeterminateStates] = useState<any>({})

  const [confirmLoading, setConfirmLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      if (payAgainPayment?.id && payAgainPayment) {
        setPageLoading(true)
        dispatch(getPaymentResults(payAgainPayment?.id))
          .then(unwrapResult)
          .then(async (val: any) => {
            const materials = val?.materials?.map((item: any) => {
              return {
                ...item,
                recoveryTip: item?.tip,
                itemList: item?.itemList?.map((b: any) => {
                  return {
                    ...b,
                    category: item?.category,
                    recoveryQuantity:
                      item?.category == RecipeCategory.Tcm
                        ? b?.countPerTip <= 0
                          ? 0
                          : b?.countPerTip
                        : b?.drugCount,
                  }
                }),
              }
            })
            setResult({
              ...val,
              materials: materials,
            })
            setDataList(materials)
          })
          .finally(() => {
            setPageLoading(false)
          })
      }
    }
  }, [visible, payAgainPayment])

  const handleParentCheckbox = (v: any, checked: any) => {
    if (checked) {
      // 选择所有子项
      const newSelectedIds = [
        ...selectedIds,
        ...v.itemList.map((item: any) => item.id),
      ]
      setSelectedIds(newSelectedIds)
    } else {
      // 取消选择所有子项
      const newSelectedIds = selectedIds.filter(
        (id: any) => !v.itemList.some((item: any) => item.id === id)
      )
      setSelectedIds(newSelectedIds)
    }
  }

  // 处理子项复选框点击
  const handleChildCheckbox = (id: any, checked: any) => {
    if (checked) {
      setSelectedIds([...selectedIds, id])
    } else {
      setSelectedIds(selectedIds.filter((selectedId: any) => selectedId !== id))
    }
  }

  // 更新不确定状态
  useEffect(() => {
    const newIndeterminateStates: any = {}
    dataList?.forEach((v: any) => {
      const childIds = v?.itemList?.map((item: any) => item.id)
      const selectedChildCount = childIds?.filter((id: any) =>
        selectedIds?.includes(id)
      ).length

      if (selectedChildCount > 0 && selectedChildCount < childIds.length) {
        newIndeterminateStates[v.id] = true
      } else {
        newIndeterminateStates[v.id] = false
      }
    })

    setIndeterminateStates(newIndeterminateStates)
  }, [selectedIds, dataList])

  function calcFixed(a:any, b:any, decimals = 2) {
    // 将数字转换为字符串以避免浮点数精度问题
    const aStr = a.toString();
    const bStr = b.toString();

    // 获取小数位数
    const aDecimals = aStr.includes('.') ? aStr.split('.')[1].length : 0;
    const bDecimals = bStr.includes('.') ? bStr.split('.')[1].length : 0;

    // 将数字转换为整数
    const aInt = parseInt(aStr.replace('.', ''), 10);
    const bInt = parseInt(bStr.replace('.', ''), 10);

    // 计算乘积（整数形式）
    const product = aInt * bInt;

    // 计算总的小数位数
    const totalDecimals = aDecimals + bDecimals;

    // 将整数乘积转换回小数
    const factor = Math.pow(10, totalDecimals);
    const actualProduct = product / factor;

    // 四舍五入到指定小数位
    const roundFactor = Math.pow(10, decimals);
    return Math.round(actualProduct * roundFactor) / roundFactor;
  }

  useEffect(() => {
    if (visible) {
      const ids = dataList
        ?.map((v?: any) => v?.itemList)
        ?.flat()
        ?.map((n: any) => n?.id)

      setSelectedIds(ids)
    } else {
      setSelectedIds([])
      setDataList([])
    }
  }, [visible, dataList?.length])

  useEffect(() => {
    if (visible) {
      if (dataList?.length) {
        const drugAmount = dataList
          ?.map((v?: any) => v?.itemList)
          ?.flat()
          ?.filter((item: any) => selectedIds?.includes(item.id))
          ?.map((n: any) => n?.drugAmount)
        setTotalAmount(sum(drugAmount)?.toFixed(2))
      } else {
        setTotalAmount('0.00')
      }
    } else {
      setTotalAmount('0.00')
    }
  }, [visible, dataList, selectedIds])
  return (
    <>
      <Modal
        width={1000}
        title='重新收费'
        destroyOnClose
        visible={visible}
        confirmLoading={confirmLoading}
        className={styles.chargeAgainModal}
        style={{ position: 'relative' }}
        onCancel={() => {
          onCancel()
          form.resetFields()
        }}
        onOk={() => {
          if (selectedIds?.length) {
            const recipeItems = dataList
              ?.map((v?: any) => {
                return v?.itemList?.map((n: any) => {
                  return {
                    ...n,
                    recoveryTip: v?.recoveryTip,
                  }
                })
              })
              ?.flat()
              .filter((item: any) => selectedIds.includes(item?.id))
              ?.map((n: any) => {
                return n?.category == RecipeCategory.Tcm
                  ? {
                      recipeItemId: n?.id,
                      drugCount: n?.recoveryQuantity,
                      tip: n?.recoveryTip,
                    }
                  : {
                      recipeItemId: n?.id,
                      drugCount: n?.recoveryQuantity,
                    }
              })
            setConfirmLoading(true)
            const params = {
              paymentId: payAgainPayment?.id,
              recipeItems: recipeItems,
            }
            dispatch(payAgainAsync(params))
              .then(unwrapResult)
              .then((res: any) => {
                if (hisVersion == 1) {
                  notification.success({
                    message: '复制完成，请到待收费页面查看新的单据。',
                  })
                  onOk()
                  setConfirmLoading(false)
                } else {
                  Modal.confirm({
                    centered: true,
                    title: '复制完成',
                    width: 320,
                    content: <div>请点击【确认】跳转并继续完成收费。</div>,
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      onOk()
                      setConfirmLoading(false)
                      dispatch(
                        traceRoute({
                          name: '医生门诊',
                          path: '/treatment',
                          query: `registrationId=${res}`,
                          state: {
                            backSelectTab: 'editor',
                          },
                        })
                      )
                    },
                    onCancel: () => {
                      setConfirmLoading(false)
                    },
                  })
                }
              })
              .catch((error) => {
                const errorMsg = error?.message || ''
                if (errorMsg.includes('处方数量不能大于10')) {
                  Modal.warning({
                    centered: true,
                    title: '提示',
                    content: '处方数量不能大于10，请重新挂号后再开方结算',
                    okText: '知道了',
                    icon: <ExclamationCircleFilled style={{ color: '#faad14' }} />,
                  })
                }
                setConfirmLoading(false)
              })
          } else {
            notification.info({
              message: '请至少选择一个处方明细',
            })
          }
        }}
      >
        <div style={{ width: '100%' }}>
          {dataList?.map((v: any) => {
            const allChildIds = v.itemList.map((item: any) => item.id)
            const allChildrenSelected = allChildIds?.every((id: any) =>
              selectedIds?.includes(id)
            )
            const someChildrenSelected = allChildIds?.some((id: any) =>
              selectedIds?.includes(id)
            )
            const amountList = v.itemList
              ?.filter((item: any) => selectedIds?.includes(item.id))
              ?.map((n: any) => n?.drugAmount)

            return (
              <div
                key={v.id}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    lineHeight: '50px',
                    borderBottom: 'none',
                    fontSize: '16px',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ width: '66%' }}>
                    <Checkbox
                      indeterminate={indeterminateStates[v.id]}
                      checked={allChildrenSelected}
                      onChange={(e) =>
                        handleParentCheckbox(v, e.target.checked)
                      }
                      style={{ marginRight: '12px' }}
                    />
                    {getRecipeCategoryName(v?.category)}处方单，处方编号：
                    {v?.id}，总金额：
                    {sum(amountList)?.toFixed(2)}
                  </div>
                  {v?.category == RecipeCategory.Tcm ? (
                    <div
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      <div>原单帖数：{v?.tip}帖，重开帖数</div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginLeft: '10px',
                        }}
                        className={styles.inputStyle}
                      >
                        <Button
                          icon={<MinusOutlined />}
                          size='small'
                          onClick={() => {
                            const recoveryTip = v?.recoveryTip - 1
                            if (recoveryTip <= 0) {
                              notification.info({
                                message: '重开帖数不能为0',
                              })
                            } else {
                              const data = dataList?.map((n: any) => {
                                return {
                                  ...n,
                                  recoveryTip:
                                    n?.id == v?.id
                                      ? recoveryTip
                                      : n?.recoveryTip,
                                  itemList: n?.itemList?.map((item: any) => {
                                    return {
                                      ...item,
                                      drugAmount:
                                        item?.category == RecipeCategory.Tcm
                                          ? n?.id == v?.id
                                            ? calcFixed(item?.retailPrice ,item?.recoveryQuantity * recoveryTip,2)
                                            : item?.drugAmount
                                          : item?.drugAmount,
                                    }
                                  }),
                                }
                              })
                              setDataList(data)
                            }
                          }}
                        />
                        <InputNumber
                          style={{
                            width: '3rem',
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                          }}
                          controls={false}
                          value={v?.recoveryTip}
                          min={1}
                          max={9999}
                          bordered={false}
                        />
                        <Button
                          icon={<PlusOutlined />}
                          size='small'
                          onClick={() => {
                            const recoveryTip = v?.recoveryTip + 1
                            const data = dataList?.map((n: any) => {
                              return {
                                ...n,
                                recoveryTip:
                                  n?.id == v?.id ? recoveryTip : n?.recoveryTip,
                                itemList: n?.itemList?.map((item: any) => {
                                  return {
                                    ...item,
                                    drugAmount:
                                      item?.category == RecipeCategory.Tcm
                                        ? n?.id == v?.id
                                          ? calcFixed(item?.retailPrice ,item?.recoveryQuantity * recoveryTip,2)
                                          : item?.drugAmount
                                        : item?.drugAmount,
                                  }
                                }),
                              }
                            })
                            setDataList(data)
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div></div>
                </div>

                <EditableList
                  style={{
                    margin: '0px 0px 0px 28px',
                  }}
                  bordered
                  loading={pageLoading}
                  size='small'
                  rowSelection={{
                    selectedRowKeys: selectedIds,
                    onSelect: (record, selected) => {
                      handleChildCheckbox(record.id, selected)
                    },
                    onSelectAll: (selected, selectedRows, changeRows) => {
                      if (selected) {
                        const newSelectedIds = [
                          ...selectedIds,
                          ...changeRows.map((row) => row.id),
                        ]
                        setSelectedIds(newSelectedIds)
                      } else {
                        const newSelectedIds = selectedIds.filter(
                          (id: any) => !changeRows.some((row) => row.id === id)
                        )
                        setSelectedIds(newSelectedIds)
                      }
                    },
                  }}
                  pagination={false}
                  dataSource={v.itemList}
                  columns={
                    v?.category == RecipeCategory.Tcm
                      ? ChargeAgainTCMColumn((val, count) => {
                          const data = dataList?.map((v: any) => {
                            return {
                              ...v,
                              itemList: v?.itemList?.map((item: any) => {
                                return {
                                  ...item,
                                  recoveryQuantity:
                                    item?.id == val?.id
                                      ? count
                                      : item?.recoveryQuantity,
                                  drugAmount:
                                    item?.id == val?.id
                                      ? calcFixed(v?.recoveryTip *count,item.retailPrice ,2)
                                      : item?.drugAmount,
                                }
                              }),
                            }
                          })
                          setDataList(data)
                        }, v?.recoveryTip)
                      : ChargeAgainColumn((val, count) => {
                          const data = dataList?.map((v: any) => {
                            return {
                              ...v,
                              itemList: v?.itemList?.map((item: any) => {
                                return {
                                  ...item,
                                  recoveryQuantity:
                                    item?.id == val?.id
                                      ? count
                                      : item?.recoveryQuantity,
                                  drugAmount:
                                    item?.id == val?.id
                                      ? calcFixed(item.retailPrice , count,2)
                                      : item?.drugAmount,
                                }
                              }),
                            }
                          })
                          setDataList(data)
                        })
                  }
                />
              </div>
            )
          })}
          <Popover
            placement='top'
            content={
              <div>
                <span style={{ fontSize: '1.3rem' }}>
                  总金额：
                  <span
                    style={{
                      color: theme.e,
                      fontSize: '1.3rem',
                      fontWeight: 'bold',
                    }}
                  >
                    ¥{totalAmount}
                  </span>
                </span>
                {dataList?.map((r: any) => (
                  <span key={r.id} style={{ marginLeft: 10 }}>
                    {getRecipeCategoryName(r.category)}：
                    <span
                      style={{
                        color: theme.tc1,
                        fontSize: '1.125rem',
                        fontWeight: 'bold',
                      }}
                    >
                      ¥
                      {sum(
                        r.itemList
                          ?.filter((item: any) =>
                            selectedIds?.includes(item.id)
                          )
                          ?.map((n: any) => n?.drugAmount)
                      )?.toFixed(2)}
                    </span>
                  </span>
                ))}
              </div>
            }
          >
            <div
              style={{
                width: '80%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                position: 'absolute',
                bottom: 8,
              }}
            >
              <span style={{ fontSize: '1.3rem' }}>
                总金额：
                <span
                  style={{
                    color: theme.e,
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                  }}
                >
                  ¥{totalAmount}
                </span>
              </span>
              {dataList?.map((r: any) => (
                <span key={r.id} style={{ marginLeft: 10 }}>
                  {getRecipeCategoryName(r.category)}：
                  <span
                    style={{
                      color: theme.tc1,
                      fontSize: '1.125rem',
                      fontWeight: 'bold',
                    }}
                  >
                    ¥
                    {sum(
                      r.itemList
                        ?.filter((item: any) => selectedIds?.includes(item.id))
                        ?.map((n: any) => n?.drugAmount)
                    )?.toFixed(2)}
                  </span>
                </span>
              ))}
            </div>
          </Popover>
        </div>
      </Modal>
    </>
  )
}
